export default {
  title: "Perfil",
  description: "Gestiona tu perfil personal",
  personalInfo: "Información personal",
  weddingInfo: "Información de la boda",
  form: {
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    phone: "Teléfono",
    weddingDate: "Fecha de la boda",
    partnerName: "Nombre de la pareja",
    venue: "Lugar",
    location: "Ubicación",
    about: "Acerca de",
    save: "Guardar cambios"
  },
  actions: {
    save: "Guardar",
    cancel: "Cancelar",
    edit: "Editar"
  },
  messages: {
    profileUpdated: "Perfil actualizado exitosamente",
    error: "Ocurrió un error",
    updateSuccess: "Perfil actualizado exitosamente",
    updateError: "Error al actualizar el perfil",
    photoUploadSuccess: "Foto subida con éxito",
    photoUploadError: "Error al subir la foto"
  },
  photo: {
    alt: "Foto de perfil",
    upload: "Subir una foto",
    change: "Cambiar foto",
    remove: "Eliminar foto"
  }
};
